import React from "react";
import { Handle, Position } from "reactflow";

export const Trigger = {
    Message: {
        Inbound: "Trigger.Message.Inbound",
        Outbound: "Trigger.Message.Outbound",
    },
} as const;

export type TriggerType = (typeof Trigger.Message)[keyof typeof Trigger.Message];

export interface TriggerNodeData {
    label?: string;
    title?: string;
    description?: string;
    triggerType?: TriggerType;
}

const TRIGGER_META: Record<TriggerType, { icon: React.ReactNode; defaultTitle: string; defaultDesc: string }> = {
    [Trigger.Message.Inbound]: {
        icon: <div className="automationIconsSprite incoming-trigger-icon"></div>,
        defaultTitle: "Incoming",
        defaultDesc: "When a message comes in"
    },
    [Trigger.Message.Outbound]: {
        icon: <div className="automationIconsSprite outgoing-trigger-icon"></div>,
        defaultTitle: "Outgoing",
        defaultDesc: "When an Outgoing Message Is Sent"
    }
};

const TriggerNodeComponent: React.FC<{ data: TriggerNodeData }> = ({ data }) => {
    const type: TriggerType = data.triggerType ?? Trigger.Message.Inbound;
    const meta = TRIGGER_META[type];
    return (
        <div className="trigger-rule-node hs-border-grey trigger-rule-node-trigger" role="article" aria-label={`Trigger: ${data.title ?? meta.defaultTitle}`}>
            <Handle type="source" position={Position.Bottom} id="source" className="trigger-rule-node-handle" />
            <span className="trigger-rule-node-tag">Trigger</span>
            <div className="trigger-rule-node-header-row d-flex align-items-center gap-2">
                <div className="trigger-rule-node-icon d-flex align-items-center justify-content-center">
                    {meta.icon}
                </div>
                <div className="trigger-rule-node-content d-flex flex-column gap-1">
                    <span className="hs-fw-600 hs-color-BlackRussian hs-fs-12">{data.title ?? meta.defaultTitle}</span>
                    <span className="trigger-rule-node-desc">{data.description ?? meta.defaultDesc}</span>
                </div>
            </div>
        </div>
    );
};

export const TriggerNode = React.memo(TriggerNodeComponent);
